import React from 'react';
import Tabs from './Tabs';

const BottomBar: React.FC = () => {
  return (
    <div className="sticky bottom-0 z-10 bg-white dark:bg-gray-900 shadow-sm border-t border-gray-300 dark:border-gray-700 overflow-visible">
      <div className="flex flex-wrap justify-between items-start gap-2 px-2 pb-0.25 w-full overflow-visible">
        <Tabs />
      </div>
    </div>
  );
};

export default BottomBar;
